export const namespace = 'fek-';
